"use client";

import { useContext, useEffect } from "react";
import { 
  type BreadcrumbItem, 
  type BreadcrumbContextValue, 
  BreadcrumbContext, 
  DEFAULT_BREADCRUMBS 
} from "./breadcrumb-defs";

const useBreadcrumbContext = (): BreadcrumbContextValue => {
  const context = useContext(BreadcrumbContext);
  if (!context) {
    throw new Error("useBreadcrumbContext must be used within a BreadcrumbProvider");
  }

  return context;
};

const usePageBreadcrumbs = (items: BreadcrumbItem[]) => {
  const { setItems } = useBreadcrumbContext();

  useEffect(() => {
    setItems(items);
  }, [items, setItems]);

  useEffect(
    () => () => {
      setItems(DEFAULT_BREADCRUMBS);
    },
    [setItems],
  );
};

export {
  useBreadcrumbContext,
  usePageBreadcrumbs,
};
